import { IMAGE_UPDATE_EVENT_TYPE } from "../../constants.js";
import GlobalController from "../base-controllers/GlobalController.js";
/** Refresh every occurrence of a completed image, including local previews. */
class ImageUpdater extends GlobalController {
    constructor() {
        super(...arguments);
        this.handleMessage = (message) => {
            if (message.data?.type === IMAGE_UPDATE_EVENT_TYPE) {
                ImageUpdater.updateImages(message.data.payload);
            }
        };
    }
    init() {
        navigator.serviceWorker.addEventListener("message", this.handleMessage);
    }
    destroy() {
        navigator.serviceWorker.removeEventListener("message", this.handleMessage);
    }
    static updateImages(payload) {
        if (!payload || typeof payload.id !== "string" || !payload.id)
            return;
        const version = typeof payload.version === "string" && payload.version
            ? payload.version : String(Date.now());
        const refreshed = (source) => {
            const url = new URL(source, document.baseURI);
            url.searchParams.set("v", version);
            return url.href;
        };
        for (const image of document.querySelectorAll(`img.${CSS.escape(payload.id)}`)) {
            if (image.getAttribute("skip-morph")?.split(/\s+/).includes("src"))
                continue;
            // A SyncImage may currently show a local data URL. Its server URL is the
            // rendition to refresh, not that square local preview.
            image.dispatchEvent(new Event(IMAGE_UPDATE_EVENT_TYPE));
            image.src = refreshed(image.dataset.originalSrc || image.src);
        }
        for (const indicator of document.querySelectorAll("[data-image-upload-info]")) {
            if (indicator.dataset.imageUploadInfo === payload.id)
                indicator.remove();
        }
        for (const link of document.querySelectorAll("a[data-image-upload-link]")) {
            if (link.dataset.imageUploadLink !== payload.id)
                continue;
            const source = link.dataset.imageOriginalUrl;
            if (!source)
                continue;
            link.href = refreshed(source);
            link.setAttribute("data-image-lightbox-link", "");
        }
    }
}
ImageUpdater.id = "ImageUpdater";
export default ImageUpdater;
//# sourceMappingURL=ImageUpdater.js.map